/* global Swiper */
/* Luxury Carousel — one Swiper instance per rendered Shopify section. */
(function () {
  'use strict';

  function numberFromData(element, name, fallback) {
    var value = Number(element.dataset[name]);
    return Number.isFinite(value) ? value : fallback;
  }

  function updateProgress(swiper, section, progressFill) {
    if (!progressFill || !swiper || !swiper.slides.length) return;

    var visibleSlides = Math.max(1, Math.ceil(swiper.slidesPerViewDynamic ? swiper.slidesPerViewDynamic() : swiper.params.slidesPerView));
    var thumbWidth = Math.min(100, (visibleSlides / swiper.slides.length) * 100);
    var progress = Math.min(1, Math.max(0, Number(swiper.progress) || 0));
    var left = (100 - thumbWidth) * progress;

    section.style.setProperty('--luxury-progress-width', thumbWidth + '%');
    section.style.setProperty('--luxury-progress-left', left + '%');
  }

  function initialiseCarousel(section) {
    if (!section || section.dataset.luxuryInitialised === 'true' || typeof Swiper === 'undefined') return;

    var slider = section.querySelector('[data-luxury-slider]');
    if (!slider) return;

    var progressFill = section.querySelector('[data-luxury-progress]');
    var nextButton = section.querySelector('[data-luxury-next]');
    var previousButton = section.querySelector('[data-luxury-prev]');
    var desktopSlides = numberFromData(section, 'desktopSlides', 4);
    var tabletSlides = numberFromData(section, 'tabletSlides', 2);
    var mobileSlides = numberFromData(section, 'mobileSlides', 1);
    var desktopGap = parseInt(getComputedStyle(section).getPropertyValue('--luxury-carousel-desktop-gap'), 10) || 64;

    var swiper = new Swiper(slider, {
      slidesPerView: mobileSlides + 0.12,
      spaceBetween: 20,
      speed: 650,
      grabCursor: true,
      watchOverflow: true,
      resistanceRatio: 0.72,
      navigation: {
        nextEl: nextButton,
        prevEl: previousButton
      },
      breakpoints: {
        750: { slidesPerView: tabletSlides + 0.2, spaceBetween: 36 },
        990: { slidesPerView: desktopSlides, spaceBetween: desktopGap }
      },
      on: {
        init: function () { updateProgress(this, section, progressFill); },
        resize: function () { updateProgress(this, section, progressFill); },
        setTranslate: function () { updateProgress(this, section, progressFill); },
        slideChange: function () { updateProgress(this, section, progressFill); }
      }
    });

    section.dataset.luxuryInitialised = 'true';
    section.luxuryCarouselSwiper = swiper;
  }

  function initialiseAll() {
    document.querySelectorAll('[data-luxury-carousel]').forEach(initialiseCarousel);
  }

  function boot() {
    // Swiper is loaded in theme.liquid. This short retry also covers a slow CDN response.
    if (typeof Swiper === 'undefined') {
      window.setTimeout(boot, 50);
      return;
    }
    initialiseAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-initialise a newly added or re-rendered section in Shopify’s theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-luxury-carousel]') || event.target;
    if (typeof Swiper === 'undefined') {
      window.setTimeout(function () { initialiseCarousel(section); }, 100);
      return;
    }
    initialiseCarousel(section);
  });
})();
